import { render, staticRenderFns } from "./NewPasswordView.vue?vue&type=template&id=412d15b0&"
import script from "./NewPasswordView.vue?vue&type=script&lang=js&"
export * from "./NewPasswordView.vue?vue&type=script&lang=js&"
import style0 from "./NewPasswordView.vue?vue&type=style&index=0&id=412d15b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports